import CardHover from "gamfi/components/cardHover";
import ProjectCardStyleWrapper from "gamfi/sections/Projects/v4/ProjectCard/ProjectCard.style";
import { useCallback } from "react";
import { addressShortener } from "utils/token";
 
interface ProjectCardProps {
  name: string;
  symbol: string;
  icon: string;
  coinIcon: string;
  address: string;
  onAddToken: () => void;
  socialLinks: {
    url: string;
    icon: string;
  }[];
  projectDetails: {
    title: string;
    text: string | number;
  }[];
}

const ProjectCard = (props: ProjectCardProps) => {
  const openExplorer = useCallback(() => {
    window.open("https://etherscan.io/token/" + props.address, "_blank", "noopener,noreferrer");
  }, [props.address]);

  return (
    <ProjectCardStyleWrapper className="project_item_wrapper">
      <div className="project-info d-flex project-icon-action" onClick={props.onAddToken}>
        <div>
          <img src={props.icon} alt="project thumb" />
        </div>
        <div className="project-auother">
          <h4 className="mb-10">
            <div>{props.name}</div>
          </h4>
          <div className="dsc">{props.symbol}</div>
        </div>
      </div>
      <div className="project-content">
        <div className="project-header d-flex justify-content-between align-items-center">
          <div className="heading-title">
            <h4>{addressShortener(props.address)}</h4>
          </div>

          <div className="project-icon-action" onClick={openExplorer}>
            <img src={props.coinIcon} alt="coin icon" />
          </div>
        </div>
        <ul className="project-listing">
          {props.projectDetails.map((item, i) => (
            <li key={i}>
              {item.title} <span>{item.text}</span>
            </li>
          ))}
        </ul>
        <div className="social-links">
          {props.socialLinks.map((profile, i) => (
            <a key={i} href={profile.url}>
              <img src={profile.icon} alt="social icon" />
            </a>
          ))}
        </div>
      </div>

      <CardHover />
    </ProjectCardStyleWrapper>
  );
};

export default ProjectCard;
